import { post } from '../../../api/commonAPI';

import toastr from 'toastr';

import {
    SAVE_HOST_DETAILS,
    SAVE_HOST_DETAILS_SUCCESS,
    SAVE_HOST_DETAILS_FAILS
} from './CreateHostActionType';


export const updateSpaceOwnerDetails = (values) => {

    return dispatch => {
        dispatch({
            type: SAVE_HOST_DETAILS
        });
        const url = `api/user`;
        post(url, values)
            .then(res => {
                dispatch({
                    type: SAVE_HOST_DETAILS_SUCCESS,
                    payload: res.data,
                })
                toastr.success("Successfully Saved")
            })
            .catch(error => {
                dispatch({
                    type: SAVE_HOST_DETAILS_FAILS,
                    payload: error,
                })
                toastr.error(error.response.data.message)
            });
    };

};